import React from "react";
import { withRouter } from "react-router-dom";
import classes from "./CompleteAssignment.module.css";
import { connect, Provider } from "react-redux";
import {
  fetchQuestions,
  getQuestion,
  clearAssessmentResponse,
  finalSubmitAssessment,
  getSelectedQuestion,
  getPreviousQuestion,
  clearQuestionWithIndex,
} from "../../../../store/actions/questions.action";
import { submitAssessment } from "../../../../store/actions/questionAnswer.action";
import { getAssessmentResponce } from "../../../../store/actions/questionAnswer.action";
import { readAssessment } from "../../../../store/actions/assessment.action";
import ClearIcon from "@material-ui/icons/Clear";
import ColorPicker from "../StartTestPage/colorPickerTool";
import Question from "./Question";
import QuestionTrueFalse from "./QuestionTrueFalse";
import QuestionMultiSelect from "./QuestionMultiSelect";
import QuestionPictureType from "./QuestionPictureType";
import QuestionTextType from "./QuestionTextType";
import store from "../../../../store/index";
import { showError } from "../../../../store/actions/error.action";
import { getFlowId } from "../../../../utils/authentication-access";
import closeLogo from "../../../../assets/img/closeIcon.svg";
import moment from "moment";
import BaseTheme from "../../../../theme/base-theme";
import { ThemeProvider } from "@material-ui/styles";
// Material UI
import { MButton, MIconButton, MPaginationButton } from "../../../../UI";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import LinearProgress from "@material-ui/core/LinearProgress";
import TextField from "@material-ui/core/TextField";
import { Button } from "@material-ui/core";

// Icons
import CloseIcon from "@material-ui/icons/Close";
import AnsweredIcon from "../../../../assets/img/assessmentLearnImages/answered.svg";
import NotAnsweredIcon from "../../../../assets/img/assessmentLearnImages/notAnswered.svg";
import NotVisitedIcon from "../../../../assets/img/assessmentLearnImages/notVisited.svg";
import MarkedReviewIcon from "../../../../assets/img/assessmentLearnImages/markedReview.svg";
import MarkedAnsweredIcon from "../../../../assets/img/assessmentLearnImages/markedAnswered.svg";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

//whiteboard
import WhiteBoard from "../../../../whiteboard-react-konva/src/components/WhiteBoard";
import { WHITEBOARD_URL } from "../../../../utils";

import { withTranslation } from "react-i18next";
import RollBackPopup from "../../RollBack/RollBackPopup";

class CompleteAssignment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      questionnum: 0,
      counter: 0,
      submitDialogToggle: false,
      paginationDialogToggle: false,
      questionResponses: [],
      timerInterval: null,
      cancelAssignment: false,
      showClose: true,
    };
  }
  async componentWillMount() {
    let assessmentId = localStorage.getItem("_assessmentId");
    await this.props.fetchQuestions(assessmentId);
    let userId = localStorage.getItem("kneuraId");
    await this.props.getAssessmentResponce(assessmentId, userId);
  }

  async componentDidMount() {
    let assessmentId = localStorage.getItem("_assessmentId");
    this.runTask("CHOOSE_MODE_TYPE", { modeType: "ARROW" });
    let userId = localStorage.getItem("kneuraId");
    if (sessionStorage.getItem("assessmentinfo")) {
      const assessmentInfo = JSON.parse(
        sessionStorage.getItem("assessmentinfo")
      );
      this.setState({ showClose: assessmentInfo.showClose });
    }

    await this.props.getAssessmentResponce(assessmentId, userId);
    await this.props.readAssessment(assessmentId);
    await this.props.fetchQuestions(assessmentId);
    await this.props.getQuestion();
    this.setState({ questionResponses: this.props.questionresponses });

    let flowid = getFlowId();
    if (flowid) {
      this.runTask("INIT_WHITEBOARD", {
        flowId: getFlowId(),
        hostName: WHITEBOARD_URL,
        theme: this.props.assessmentData.setting.theme,
      });
    }
    this.startTimer();
  }

  componentWillReceiveProps(props) {
    if (this.props.questionResponses !== props.questionResponses) {
      this.setState({ questionResponses: this.props.questionresponses });
    }
  }

  gotoassessment = () => {
    clearTimeout(this.state.timerInterval);
    this.props.history.goBack();
    this.props.history.goBack();
  };

  startTimer() {
    let now = moment();
    let end = moment(this.props.assessmentresponse.startTime);
    let duration = moment.duration(now.diff(end));
    let seconds = duration.asSeconds();
    this.setState({ counter: seconds });

    let timelimit = this.props.assessmentData.setting.timeLimit;

    if (timelimit <= 0) {
      return;
    }

    // todo need to fix this timer logic
    if (seconds < timelimit * 60) {
      let remainingtime = timelimit * 60 - seconds;
      this.setState({ counter: remainingtime });
      let timer = setInterval(() => {
        this.setState({
          timer: moment()
            .hour(0)
            .minute(0)
            .second(this.state.counter--)
            .format("HH : mm : ss"),
        });
        if (Math.floor(this.state.counter) == 300) {
          store.dispatch(showError("Hurry 5 minutes to go"));
        } else if (Math.floor(this.state.counter) == 60) {
          store.dispatch(showError("Hurry 1 minute to go"));
        } else if (Math.floor(this.state.counter) <= 0) {
          clearTimeout(this.state.timerInterval);
          this.submitAssessment();
          store.dispatch(showError("Assessment Auto Submitted.. Time Out"));
        }
      }, 1000);
      this.setState({ timerInterval: timer });
    } else if (
      this.props.assessmentData.setting.timeLimit == undefined ||
      this.props.assessmentData.setting.timeLimit <= 0
    ) {
      let timer = setInterval(() => {
        this.setState({
          timer: moment()
            .hour(0)
            .minute(0)
            .second(this.state.counter++)
            .format("HH : mm : ss"),
        });
      }, 1000);
      this.setState({ timerInterval: timer });
    } else {
      this.submitAssessment();
      store.dispatch(showError("Assessment Auto Submitted.. Time Out"));
    }
  }

  dialogOpenHandler = (dialogName) => (event) => {
    this.setState((prevState) => ({ ...prevState, [dialogName]: true }));
  };

  dialogCloseHandler = (dialogName) => (event) => {
    this.setState((prevState) => ({ ...prevState, [dialogName]: false }));
  };

  paginationButtonClickHandler = async () => {
    let assessmentId = localStorage.getItem("_assessmentId");
    let userId = localStorage.getItem("kneuraId");
    await this.props.getAssessmentResponce(assessmentId, userId);
    this.paginationQuestionLables();
    this.setState((prevState) => ({ paginationDialogToggle: true }));
  };

  submitDialogCloseHandler = () => {
    this.props.submitAssessment(false);
  };

  submitBtnClick = async () => {
    let assessmentId = localStorage.getItem("_assessmentId");
    let userId = localStorage.getItem("kneuraId");
    await this.props.getAssessmentResponce(assessmentId, userId);
    this.props.submitAssessment(true);
  };

  submitAssessment = async () => {
    await this.props.finalSubmitAssessment(this.props.assesmentresponseid);
    this.submitDialogCloseHandler();
    let redirectToEvaluationPending = false;
    this.props.questions.forEach((question) => {
      if (question.type === "SUBJECTIVE") {
        redirectToEvaluationPending = true;
      }
    });
    if (redirectToEvaluationPending) {
      this.props.history.replace("/assessments/evaluation-pending");
    }
    if (!redirectToEvaluationPending) {
      this.props.history.replace("/test-submitted");
    }
  };

  getSelectedQuestion = (index) => async (event) => {
    await this.props.clearQuestionWithIndex();
    this.props.getSelectedQuestion(index);
    this.setState({ paginationDialogToggle: false });
    this.runTask("CHANGE_PAGE_NUMBER", { pageNumber: index });
  };

  paginationPreviousClickHandler = async () => {
    if (this.props.questionindex > 0) {
      await this.props.clearQuestionWithIndex();
      this.props.getSelectedQuestion(this.props.questionindex - 1);
      this.runTask("CHANGE_PAGE_NUMBER", {
        pageNumber: this.props.questionindex - 1,
      });
    }
  };

  paginationNextClickHandler = async () => {
    if (
      this.props.questionindex + 1 <
      this.props.assessmentresponse.totalNumberOfQuestions
    ) {
      await this.props.clearQuestionWithIndex();
      this.props.getSelectedQuestion(this.props.questionindex + 1);
      this.runTask("CHANGE_PAGE_NUMBER", {
        pageNumber: this.props.questionindex + 1,
      });
    }
  };

  paginationQuestionLables = () => {
    const paginationLables = this.props.questionresponses.map((item, index) => {
      let classType = "";
      if (item.isVisited === false) {
        classType = classes.QuestionLabelNotVisited;
      }
      if (item.isVisited === true) {
        classType = classes.QuestionLabelNotAnswered;
      }
      if (item.isAnswered === true) {
        classType = classes.QuestionLabelAnswered;
      }
      if (item.isMarked === true) {
        classType = classes.QuestionLabelMarked;
      }
      if (item.isMarked === true && item.isAnswered === true) {
        classType = classes.QuestionLabelMarkedAnswered;
      }

      return (
        <div className={classType} onClick={this.getSelectedQuestion(index)}>
          {index + 1}
        </div>
      );
    });
    return paginationLables;
  };

  handleColorSelect = (selectedColor) => {
    this.runTask("CHOOSE_MODE_TYPE", { modeType: "PENCIL" });
    this.runTask("CHANGE_PENCIL_MODE_COLOR", { color: selectedColor });
  };

  performUndo = () => {
    this.runTask("PERFORM_UNDO", {});
  };

  clearBoard = () => {
    this.runTask("CLEAR_ALL", {});
  };

  closeAssignmentDialog = () => {
    this.setState({ cancelAssignment: false });
  };

  openAssignmentDialog = () => {
    this.setState({ cancelAssignment: true });
  };

  renderQuestionsHandler = () => {
    // this.props.question.type == "MULTIPLE_CHOICE" ? (
    //   <Question mode="test" />
    // ) : this.props.question.type == "TRUE_FALSE" ? (
    //   <QuestionTrueFalse mode="test" />
    // ) : this.props.question.type == "PICTURE_CHOICE" ? (
    //   <QuestionPictureType mode="test" />
    // ) : this.props.question.type == "MULTIPLE_SELECT" ? (
    //   <QuestionMultiSelect mode="test" />
    // ) : (
    //   <div>No Question To Display</div>
    switch (this.props.question.type) {
      case "MULTIPLE_CHOICE":
        return <Question mode="test" />;
      case "TRUE_FALSE":
        return <QuestionTrueFalse mode="test" />;
      case "PICTURE_CHOICE":
        return <QuestionPictureType mode="test" />;
      case "MULTIPLE_SELECT":
        return <QuestionMultiSelect mode="test" />;
      case "SUBJECTIVE":
        return <QuestionTextType mode="test" />;
      default:
        return <div>No Question To Display</div>;
    }
  };

  render() {
    const { t } = this.props;
    return (
      <>
        <RollBackPopup />
        <WhiteBoard
          store={store}
          setClick={(action) => (this.runTask = action)}
        >
          <Provider store={store}>
            <ThemeProvider theme={BaseTheme}>
              <div
              /*className={classes.testheader}*/
              >
                <ClearIcon
                  className={classes.pointercursor}
                  style={{
                    color: "#5b697d",
                    pointer: "cursor",
                    position: "absolute",
                    top: "25px",
                    left: "25px",
                  }}
                  onClick={this.openAssignmentDialog}
                />
                <div
                  className={classes.timertext}
                  style={{
                    position: "absolute",
                    top: "25px",
                    left: (window.innerWidth - 100) / 2,
                  }}
                >
                  {this.state.timer}
                </div>
                <div
                  style={{
                    position: "absolute",
                    top: "25px",
                    left: window.innerWidth - 150,
                  }}
                >
                  <Button
                    disableElevation
                    variant="contained"
                    // className={classes.SubmitBtn}
                    color="primary"
                    onClick={this.submitBtnClick}
                  >
                    {t("Submit")}
                  </Button>
                </div>
              </div>
              {/* Test Body */}
              <div
                /*className={classes.testcontent}*/ style={{
                  position: "absolute",
                  top:
                    this.props.question.images &&
                    this.props.question.images.length !== 0
                      ? window.innerHeight / 3 - 106
                      : window.innerHeight / 3,
                  left: window.innerWidth / 5,
                  height: "315px",
                  width: window.innerWidth / 2,
                  overflowY: "scroll",
                }}
              >
                {this.props.question ? (
                  this.renderQuestionsHandler()
                ) : (
                  <div>{t("No Question To Display")}</div>
                )}
              </div>
              {/* Test Footer */}
              <div
              /*className={classes.testfooter}*/
              >
                <div
                  style={{ position: "absolute", bottom: "15px", left: "25px" }}
                >
                  <ColorPicker
                    onColorSelect={this.handleColorSelect}
                    undoaction={this.performUndo}
                    clearAllaction={this.clearBoard}
                  />
                </div>
                <div
                  style={{
                    position: "absolute",
                    bottom: "15px",
                    right: 300,
                  }}
                >
                  <div
                    style={{
                      display: "inline-block",
                      marginRight: "2vw",
                      width: "15vw",
                    }}
                  >
                    <p
                      style={{
                        color: "rgba(52, 73, 94, 0.75)",
                        margin: "0 0 10px 0",
                      }}
                    >
                      {" "}
                      {this.props.assessmentresponse.answered} of{" "}
                      {this.props.assessmentresponse.totalNumberOfQuestions}{" "}
                      {t("answered")}
                    </p>
                    <LinearProgress
                      variant="determinate"
                      value={
                        (this.props.assessmentresponse.answered /
                          this.props.assessmentresponse
                            .totalNumberOfQuestions) *
                        100
                      }
                      style={{ background: "rgba(52, 73, 94, 0.25)" }}
                    />
                  </div>
                </div>
                <div
                  style={{ position: "absolute", bottom: "15px", right: 25 }}
                >
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      padding: "1vh 1vw",
                      background: "#fff",
                      borderRadius: "1vh",
                    }}
                  >
                    <MIconButton
                      onClick={this.paginationPreviousClickHandler}
                      size="small"
                    >
                      <ChevronLeftIcon />
                    </MIconButton>
                    <MPaginationButton
                      onClick={this.paginationButtonClickHandler}
                    >
                      <span style={{ color: "rgba(52, 73, 94, 1)" }}>
                        {this.props.questionindex + 1} /{" "}
                        {this.props.assessmentresponse.totalNumberOfQuestions
                          ? this.props.assessmentresponse.totalNumberOfQuestions
                          : 1}
                      </span>
                    </MPaginationButton>
                    <MIconButton
                      onClick={this.paginationNextClickHandler}
                      size="small"
                    >
                      <ChevronRightIcon />
                    </MIconButton>
                  </div>
                </div>
              </div>

              {/* Submit Dialog Starts */}
              <Dialog
                open={this.props.submitStatus}
                onClose={this.submitDialogCloseHandler}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="sm"
                fullWidth
              >
                <DialogTitle
                  id="alert-dialog-title"
                  style={{
                    background: "rgba(100, 65, 164, 0.25)",
                    display: "flex",
                    flexDirection: "row-reverse",
                    padding: "8px 24px 4px 24px",
                  }}
                >
                  <MIconButton onClick={this.submitDialogCloseHandler}>
                    <CloseIcon style={{ color: "#fff" }} />
                  </MIconButton>
                </DialogTitle>
                <DialogContent>
                  <DialogContentText
                    id="alert-dialog-description"
                    style={{ padding: "0 3vw" }}
                  >
                    <h1>{t("Are you sure you want to submit")}?</h1>
                    <p>
                      <img src={AnsweredIcon} alt="answeredIcon" />{" "}
                      {t("Answered")}: {this.props.assessmentresponse.answered}{" "}
                    </p>
                    <p>
                      <img src={NotAnsweredIcon} alt="answeredIcon" />{" "}
                      {t("Not answered")}:{" "}
                      {this.props.assessmentresponse.totalNumberOfQuestions -
                        this.props.assessmentresponse.answered}{" "}
                    </p>
                    <p>
                      <img src={NotVisitedIcon} alt="answeredIcon" />{" "}
                      {t("Not visited")}:{" "}
                      {this.props.assessmentresponse.totalNumberOfQuestions -
                        this.props.assessmentresponse.visited}{" "}
                    </p>
                    <p>
                      <img src={MarkedReviewIcon} alt="answeredIcon" />{" "}
                      {t("Marked for review")}:
                      {this.props.assessmentresponse.markedForReview}{" "}
                    </p>
                    <p>
                      <img src={MarkedAnsweredIcon} alt="answeredIcon" />{" "}
                      {t("Marked and answered")}:
                      {this.props.assessmentresponse.markedAndAnswered}{" "}
                    </p>
                  </DialogContentText>
                </DialogContent>
                <DialogActions style={{ margin: "0 1vw 1vh 1vw" }}>
                  {/* Cancel Button */}
                  <MButton
                    onClick={this.submitDialogCloseHandler}
                    variant="outlined"
                  >
                    {t("Cancel")}
                  </MButton>
                  {/* Submit Button */}
                  <MButton
                    onClick={this.submitAssessment}
                    className={classes.DialogSubmitBtn}
                    variant="contained"
                    autoFocus
                  >
                    {t("Submit")}
                  </MButton>
                </DialogActions>
              </Dialog>
              {/* Submit Dialog Ends */}

              {/* Pagination Dialog Starts */}
              <Dialog
                open={this.state.paginationDialogToggle}
                onClose={this.dialogCloseHandler("paginationDialogToggle")}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="md"
                fullWidth
              >
                <DialogTitle
                  id="alert-dialog-title"
                  style={{
                    background: "rgba(100, 65, 164, 0.25)",
                    display: "flex",
                    flexDirection: "row-reverse",
                    padding: "8px 24px 4px 24px",
                  }}
                >
                  <MIconButton
                    onClick={this.dialogCloseHandler("paginationDialogToggle")}
                  >
                    <CloseIcon style={{ color: "#fff" }} />
                  </MIconButton>
                </DialogTitle>
                <DialogContent>
                  <DialogContentText
                    id="alert-dialog-description"
                    style={{ padding: "0 3vw" }}
                  >
                    {/* Icons List */}
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <p style={{ display: "inline", marginRight: "1vw" }}>
                        <img src={AnsweredIcon} alt="answeredIcon" />{" "}
                        {t("Answered")}
                      </p>
                      <p style={{ display: "inline", marginRight: "1vw" }}>
                        <img src={NotAnsweredIcon} alt="answeredIcon" />{" "}
                        {t("Not answered")}
                      </p>
                      <p style={{ display: "inline", marginRight: "1vw" }}>
                        <img src={NotVisitedIcon} alt="answeredIcon" />{" "}
                        {t("Not visited")}
                      </p>
                      <p style={{ display: "inline", marginRight: "1vw" }}>
                        <img src={MarkedReviewIcon} alt="answeredIcon" />{" "}
                        {t("Marked for review")}
                      </p>
                      <p style={{ display: "inline", marginRight: "1vw" }}>
                        <img src={MarkedAnsweredIcon} alt="answeredIcon" />{" "}
                        {t("Marked and answered")}
                      </p>
                    </div>
                    <hr
                      style={{ border: "2px solid rgba(52, 73, 94, 0.25)" }}
                    />
                    <div>{this.paginationQuestionLables()}</div>
                  </DialogContentText>
                </DialogContent>
              </Dialog>
              {/* Pagination Dialog Ends */}
              {/* </div> */}
              {/* Assessment close Dialog */}
              <Dialog
                fullWidth={true}
                maxWidth={"sm"}
                className="overlay"
                open={this.state.cancelAssignment}
                onClose={this.closeAssignmentDialog}
              >
                <div
                  className="dialog-modal-header "
                  style={{ background: "#0074e4" }}
                >
                  <div />
                  <div className="text-center">
                    <img
                      className="close-icon hover"
                      onClick={this.closeAssignmentDialog}
                      src={closeLogo}
                      alt="Close"
                    />
                  </div>
                </div>
                <div className="modal-card">
                  <div className="modal-title" style={{ paddingBottom: 10 }}>
                    {t("Are you sure want to pause the test")}?
                  </div>
                  <div className="modal-title" style={{ fontSize: 16 }}>
                    {t("Resume it Later")}
                  </div>

                  <DialogActions>
                    <button
                      className="btn-button-blank"
                      onClick={this.closeAssignmentDialog}
                    >
                      {t("Cancel")}
                    </button>
                    <button
                      className="btn-button-learn"
                      onClick={this.gotoassessment}
                    >
                      {t("Confirm")}
                    </button>
                  </DialogActions>
                </div>
              </Dialog>
              {/* Assessment cancel Dialog */}
            </ThemeProvider>
          </Provider>
        </WhiteBoard>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    questions: state.questionsReducer.questions,
    question: state.questionsReducer.question,
    questionresponses: state.questionanswer.assessmentresponse.questionResponses
      ? state.questionanswer.assessmentresponse.questionResponses
      : [],
    assessmentresponse: state.questionanswer.assessmentresponse,
    assesmentresponseid: state.questionanswer.assessmentresponse.id,
    questionindex: state.questionsReducer.questionIndex,
    submitStatus: state.questionanswer.submitstatus,
    assessmentData: state.assessmentsReducer.assessmentdata,
  };
};

export default connect(mapStateToProps, {
  fetchQuestions,
  getQuestion,
  clearAssessmentResponse,
  getAssessmentResponce,
  submitAssessment,
  finalSubmitAssessment,
  getSelectedQuestion,
  getPreviousQuestion,
  readAssessment,
  clearQuestionWithIndex,
})(withRouter(withTranslation()(CompleteAssignment)));
